import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BoldBorderOutlineButton, PrimaryButton } from "../../../../Constant";
import { BOLD_OUTLINE_BUTTONS, BOLD_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const BoldBorderOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={BoldBorderOutlineButton} span={BOLD_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary-2x" id="Tooltip-47">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-47" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-outline-primary-2x</ToolTip>
          {BOLD_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} outline={true}/>
          ))}
        </CardBody>
      </Card>
    );
};

export default BoldBorderOutlineButtons;
